module.exports = __webpack_public_path__ + "static/img/qr_down.96e3d23.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qr_down.png
// module id = 6bSg
// module chunks = 1